// Rich Forms — client-side mirror of backend services/form_logic.py
// Conditional visibility (show_if) evaluation used by the mobile form renderer.

const asText = (v) => {
  if (v === null || v === undefined) return '';
  if (typeof v === 'boolean') return v ? 'yes' : 'no';
  return String(v).trim();
};

const isYes = (v) => (typeof v === 'boolean' ? v : ['yes', 'true', '1'].includes(asText(v).toLowerCase()));
const isNo = (v) => (typeof v === 'boolean' ? !v : ['no', 'false', '0'].includes(asText(v).toLowerCase()));

const answerTokens = (a) => (Array.isArray(a) ? a.map((x) => asText(x).toLowerCase()) : [asText(a).toLowerCase()]);
const splitList = (value) =>
  Array.isArray(value)
    ? value.map((x) => asText(x).toLowerCase())
    : asText(value).split(',').map((p) => p.trim().toLowerCase()).filter(Boolean);

export function evaluateCondition(cond, data) {
  if (!cond || !cond.field) return false;
  const op = (cond.op || 'equals').toLowerCase();
  const answer = (data || {})[cond.field];
  const target = cond.value;

  if (op === 'not_empty') return answerTokens(answer).some((t) => t);
  if (op === 'is_empty') return !answerTokens(answer).some((t) => t);
  if (op === 'is_yes') return isYes(answer);
  if (op === 'is_no') return isNo(answer);

  const ansText = asText(answer).toLowerCase();
  const tgtText = asText(target).toLowerCase();
  const ansTokens = answerTokens(answer);

  if (op === 'equals') return Array.isArray(answer) ? ansTokens.includes(tgtText) : ansText === tgtText;
  if (op === 'not_equals') return Array.isArray(answer) ? !ansTokens.includes(tgtText) : ansText !== tgtText;
  if (op === 'in') { const w = splitList(target); return ansTokens.some((t) => t && w.includes(t)); }
  if (op === 'not_in') { const w = splitList(target); return !ansTokens.some((t) => t && w.includes(t)); }
  if (op === 'contains') return ansText.includes(tgtText);
  if (op === 'gt' || op === 'lt') {
    const a = parseFloat(asText(answer)); const b = parseFloat(asText(target));
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    return op === 'gt' ? a > b : a < b;
  }
  return false;
}

export function fieldVisible(field, data) {
  const si = field?.show_if;
  if (!si || !si.field) return true;
  return evaluateCondition(si, data);
}

// Operator labels for the builder UI
export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'does not equal' },
  { value: 'is_yes', label: 'is Yes' },
  { value: 'is_no', label: 'is No' },
  { value: 'in', label: 'is any of (comma list)' },
  { value: 'not_in', label: 'is none of (comma list)' },
  { value: 'contains', label: 'contains text' },
  { value: 'not_empty', label: 'is answered' },
  { value: 'is_empty', label: 'is blank' },
  { value: 'gt', label: 'greater than' },
  { value: 'lt', label: 'less than' },
];
